"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = void 0;
function sort(a, b, orderBy) {
    var aValue = a[orderBy];
    var bValue = b[orderBy];
    if (typeof aValue === 'boolean' || typeof aValue === 'undefined') {
        aValue = aValue ? 1 : 0;
        bValue = bValue ? 1 : 0;
    }
    if (bValue < aValue) {
        return -1;
    }
    if (bValue > aValue) {
        return 1;
    }
    if (b.id < a.id) {
        return -1;
    }
    if (b.id > a.id) {
        return 1;
    }
    return 0;
}
exports.sort = sort;
exports.default = sort;
//# sourceMappingURL=sort.js.map